// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-wrapper[data-v-22732bbf]{position:absolute;display:flex;justify-content:center;align-items:center;height:100vh;width:100vw;z-index:1000;background:#fff;top:0;left:0;overflow:hidden}.center[data-v-22732bbf]{display:block;text-align:center;overflow:hidden}", ""]);
// Exports
module.exports = exports;
